var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[(_vm.step == 0)?_c('div',{staticClass:"giveup btn",on:{"click":_vm.giveup}},[_vm._v(" 放弃注册 ")]):_vm._e(),(_vm.step != 0)?_c('div',{staticClass:"giveup btn",on:{"click":_vm.back}},[_vm._v(" 上一步 ")]):_vm._e(),_c('div',{staticClass:"confirm btn",on:{"click":_vm.confirm}},[_vm._v(" 确认 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }